import { useState } from 'react';

import Util from 'service/util';

const getType = (item) => {
  if (item.is_email) return 'Email';
  if (item.is_whatsapp) return 'WhatsApp';
  return '不詳'
}

const EInvoiceRow = ({item, onChange, onSend}) =>
{
  const [refresh, onRefresh] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const selectItem = (e) => {
    item.selected = !!e.target.checked;
    onRefresh(!refresh);
    onChange?.();
  }

  const getSendAction = (flag) => 
  {
    return () => {
      setDisabled(true);
      onSend([item], flag).then(() => {
        setTimeout(() => setDisabled(false), 10000); // 10s
      });
    }
  }

  return (
    <tr className={item.cd_license}>
      <td className="col-einv-checkbox">
      <input type="checkbox" checked={!!item.selected}
        onChange={selectItem}/>
      </td>
      <td className="col-einv-company">{ Util.getCompanyName(item.company) }</td>
      <td className="col-einv-location">{ `${item.srv_dis}${item.srv_loc}` }</td>
      <td className="col-einv-license">{ item.cd_license }</td>
      <td className="col-einv-type">{ getType(item) }</td>
      <td className="col-einv-btn-email">
        { !!item.is_email && <button className="btn blue small" onClick={getSendAction('is_email')} disabled={disabled}>Email</button> }
      </td>
      <td className="col-einv-btn-whatsapp">
        { !!item.is_whatsapp && <button className="btn green small" onClick={getSendAction('is_whatsapp')} disabled={disabled}>WhatsApp</button> }
      </td>
    </tr>
  );
}

export default EInvoiceRow;